<div
  class="card card mr-1 mb-2 shadow p-3 border-info h-100"
  [ngbPopover]="activitySummary"
  [popoverTitle]="activityTitle"
  triggers="mouseenter:mouseleave"
  [openDelay]="200"
  [closeDelay]="400"
>
  <div class="card-body p-3 d-flex flex-column">
    <p class="card-text p-y-1">
      {{ activity?.name | ellipsis: 50 }}
    </p>
    <p class="card-text p-y-2">
      {{ activity?.issues | ellipsis: 100 }}
    </p>
    <h5 class="card-title">
      Created on {{ activity?.dataDate | date: "shortDate" }}
    </h5>
    <button
      class="btn btn-success btn-sm rounded-0 mr-3 mt-auto"
      type="button"
      data-toggle="tooltip"
      data-placement="top"
      title="Delete"
      (click)="openDrivingActivityEditModal(template)"
    >
      <fa-icon [icon]="faEdit"></fa-icon>
    </button>
  </div>
</div>

<ng-template #template let-modal>
  <div role="dialog">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Upload Project</h4>
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="modal.close('Modal closed')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <app-driving-activity-form
        [drivingActivity]="activity"
        [isEditing]="true"
        [editingFromReports]="true"
        (editActivity)="onEditActivity($event)"
        (editFailed)="onEditFailed()"
      ></app-driving-activity-form>
    </div>
  </div>
</ng-template>

<ng-template #activityTitle>
  {{ activity?.name }} - Open since {{ activity?.dataDate }}
</ng-template>

<ng-template #activitySummary>
  <h4>
    Action Party: <strong>{{ activity?.actionParty }}</strong>
  </h4>
  <h4>
    Status: <strong>{{ activity?.status }}</strong>
  </h4>
  {{ activity?.issues | ellipsis: 200 }}
</ng-template>
